// apps/client/src/layout/MinimalAppWrapper.tsx

import { AppBar, Box, CssBaseline, IconButton, Toolbar, Typography } from '@mui/material';
import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { ProfileMenu } from '../components/ProfileMenu';
import UserAvatar from '../components/UserAvatar';
import { useAuth } from '../contexts/AuthContext';
import { Logo } from '../components/Logo';

/**
 * Minimal app wrapper for mobile-optimized pages (like record collection)
 * No sidebar, just minimal header with branding and user menu
 */
export const MinimalAppWrapper: React.FC = () => {
  const { user, currentOrganisation } = useAuth();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100vh' }}>
      <CssBaseline />
      <AppBar position="static">
        <Toolbar>
          <Logo />
          <Box sx={{ flexGrow: 1 }} />
          {user && (
            <>
              <IconButton size="large" onClick={handleMenu} color="inherit">
                <UserAvatar
                  initials={
                    (user?.firstName?.[0] || '')?.toUpperCase() +
                    (user?.lastName?.[0] || '')?.toUpperCase()
                  }
                  avatarUrl={user?.avatarUrl || undefined}
                  size="small"
                  color="primary.main"
                />
              </IconButton>
              <ProfileMenu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleClose}
                user={user}
                userRole={currentOrganisation?.role as any}
              />
            </>
          )}
        </Toolbar>
      </AppBar>
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          bgcolor: 'background.default',
          overflow: 'auto',
          p: { xs: 2, sm: 3 },
        }}
      >
        <Outlet />
      </Box>
    </Box>
  );
};

export default MinimalAppWrapper;
